/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { LedgerWithdrawOptions, LedgerWithdrawResponses } from '../types/LedgerWithdraw'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Withdraw assets from this user's account to the outside world. Note that this does not interact with any external systems; it simply deducts the amount from the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Withdraw assets from this user to the outside world
 * {@link /v1/ledger/withdraw/:user_id}
 */
export function ledgerWithdraw<ThrowOnError extends boolean = true>(
  options: Options<LedgerWithdrawOptions, ThrowOnError>,
): Unwrappable<RequestResult<LedgerWithdrawResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/ledger/withdraw/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LedgerWithdrawResponses, ThrowOnError>>,
  )
}
